module.exports = __webpack_public_path__ + "img/lightbox-good.a193b47e.svg";